define(function (require, exports, module) {
    'use strict';

    var removeHtml = require('../tools/string/removeHtml');
    var UploadError = require('./UploadError');

    /**
     * @constructor
     * @extends {UploadError}
     * @param {Error} stack
     * @param {string} source
     * @param {string} responseText
     */
    function MalformedError(stack, source, responseText) {
        UploadError.apply(this, arguments);

        this.responseText = removeHtml(responseText).trim().slice(0, 1000);
    }

    MalformedError.prototype = Object.assign(Object.create(UploadError.prototype), {
        constructor: MalformedError,
        className: 'MalformedError',
        radarName: 'error_{SOURCE}_malformed',
        message: 'Неизвестный формат данных.',
        responseText: '',

        toLogStringPattern: '[{TIME}] {ID} {SOURCE} {CLASS_NAME} { {META} }: {RESPONSE_TEXT}',

        toLogString: function () {
            var result = UploadError.prototype.toLogString.apply(this, arguments);

            result = result.replace('{RESPONSE_TEXT}', this.responseText);

            return result;
        },

        getDetails: function () {
            var details = UploadError.prototype.getDetails.apply(this, arguments);

            details.responseText = this.responseText;

            return details;
        },
    });

    module.exports = MalformedError;
});
